import { render } from "./DeveloperColumn.vue?vue&type=template&id=810c9ca2"
import script from "./DeveloperColumn.vue?vue&type=script&lang=js"
export * from "./DeveloperColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__